import {logAction} from "../../../logging/logEvent";

export const TIME_PERIOD_SELECTED = "TIME_PERIOD_SELECTED";
export const DEFAULT_TIME_PERIOD = 'none';
export const DEFAULT_SELECTED_TIME_PERIOD_NAME = "None (show absolute)";

export const IDEAS_SCOPE_SELECTED_TYPE = "IDEAS_SCOPE_SELECTED";
export const YOUR_CONTRIBUTORS = "YOUR_CONTRIBUTORS";

export const SORT_CHANGED_TYPE = "SORT_FUNCTION_CHANGE";

export const INITIAL_STATE = {
    sortField:      "sector",
    sortReversed:   false,
    ideasScope:     YOUR_CONTRIBUTORS,
    timePeriod:     DEFAULT_TIME_PERIOD,
    timePeriodName: DEFAULT_SELECTED_TIME_PERIOD_NAME
};

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case "SUBSCRIPTION_DATA_ARRIVED/SECTOR_SUMMARIES":
            if (action.payload.sectors) {
                const sectorNames = action.payload.sectors;
                const yourIdeaCounts = action.payload.contributorsToday;

                const yourContributorsAverages = embedNames(action.payload.contributorsAverages, sectorNames);

                return {
                    ...state,
                    yourContributors:         sectorNames.map((name, index) => ({name: name, ...yourIdeaCounts[index]})),
                    yourContributorsAverages: yourContributorsAverages
                };
            } else {
                return state;
            }
        case TIME_PERIOD_SELECTED:
            return {
                ...state,
                timePeriod:     action.timePeriod,
                timePeriodName: action.timePeriodName
            };
        case IDEAS_SCOPE_SELECTED_TYPE:
            return {
                ...state,
                ideasScope: action.ideasScope
            };
        case SORT_CHANGED_TYPE:
            return {
                ...state,
                sortField: action.sortField,
                sortReversed: action.sortReversed
            };
        default:
            return state;
    }
}

function embedNames(averages, sectorNames) {
    return {
        oneWeek:  sectorNames.map((name, index) => ({name: name, ...averages.oneWeek[index]})),
        oneMonth: sectorNames.map((name, index) => ({name: name, ...averages.oneMonth[index]})),
        oneYear:  sectorNames.map((name, index) => ({name: name, ...averages.oneYear[index]}))
    };
}

export default dispatch => ({
    selectTimePeriod(timePeriod, timePeriodName) {
        dispatch(logAction({type: TIME_PERIOD_SELECTED, timePeriod: timePeriod, timePeriodName: timePeriodName}));
    },
    selectIdeasScope(ideasScope) {
        dispatch(logAction({type: IDEAS_SCOPE_SELECTED_TYPE, ideasScope: ideasScope}));
    },
    changeSort(sortField, sortReversed) {
        dispatch(logAction({type: SORT_CHANGED_TYPE, sortField: sortField, sortReversed: sortReversed}));
    }
});
